import Delete from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { get, toLower } from "lodash";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import { propertyTypeFilterOptions } from "./constants";
import "./MixedUse.css";

const StyledCenterCell = styled("div")({
    fill: "#9e9e9e",
    alignContent: "center",
});

const StyledTheCounter = styled("span")({
    border: "1px solid #2C99D2",
    borderRadius: "50%",
    display: "inline-block",
    textAlign: "center",
    fontSize: "14px",
    fontWeight: 600,
    minWidth: "20px",
    minHeight: "20px",
});

const StyledShrinkButton = styled(Button)({
    padding: 0,
    minWidth: 0,
    minHeight: 0,
    margin: 0,
    color: "#9e9e9e",
    "&:hover": {
        backgroundColor: "transparent",
    },
});

const StyledUnitCountContainer = styled("div")(({ isFirst }) => ({
    minWidth: "20%",
    flex: "20 20 0",
    ...(isFirst && {
        paddingRight: "24px",
    }),
}));

const MixedUseDetail = (props) => {
    const {
        dataPathPrefix,
        disableInputs,
        element,
        elementIndex,
        errors,
        handleBlurValidate,
        handleUpdateArrayElement,
        onDelete,
    } = props;

    return (
        <div>
            <div className="mixedUseFlexContainer">
                <div className="mixedUseCounterContainer">
                    <StyledTheCounter>{parseInt(elementIndex) + 1}</StyledTheCounter>
                </div>
                <div className="mixedUseFields">
                    <BSSelect
                        id="propertyType"
                        label={elementIndex === 0 ? "Property Type" : null}
                        error={get(errors, `mixedUses.${elementIndex}.propertyType`, null)}
                        value={element ? element.propertyType : null}
                        onChange={(e) =>
                            handleUpdateArrayElement(
                                dataPathPrefix + ".mixedUses",
                                elementIndex,
                                e.target.id,
                                e.target.value
                            )
                        }
                        options={propertyTypeFilterOptions()}
                        disabled={disableInputs}
                    />
                </div>
                <div className="mixedUseFields">
                    <BSInput
                        id="sf"
                        label={elementIndex === 0 ? "Square Feet" : null}
                        errorText="(ex. 98101)"
                        placeholder="SF"
                        value={element ? element.sf : null}
                        error={get(errors, `mixedUses.${elementIndex}.sf`, null)}
                        onChange={(e) =>
                            handleUpdateArrayElement(
                                dataPathPrefix + ".mixedUses",
                                elementIndex,
                                e.target.id,
                                e.target.value
                            )
                        }
                        disabled={disableInputs}
                        integer
                        onBlurValidate={(id, value) => handleBlurValidate("mixedUse", id, value)}
                    />
                </div>

                <StyledUnitCountContainer isFirst={elementIndex === 0}>
                    <BSInput
                        id="unitCount"
                        label={elementIndex === 0 ? "Unit Count" : null}
                        placeholder="Unit Count"
                        errorText="(ex. 98)"
                        value={element ? element.unitCount : null}
                        error={get(errors, `mixedUses.${elementIndex}.unitCount`, null)}
                        onChange={(e) =>
                            handleUpdateArrayElement(
                                dataPathPrefix + ".mixedUses",
                                elementIndex,
                                e.target.id,
                                e.target.value
                            )
                        }
                        disabled={
                            disableInputs ||
                            (element &&
                                toLower(element.propertyType) !== "hospitality" &&
                                toLower(element.propertyType) !== "multifamily")
                        }
                        onBlurValidate={(id, value) => handleBlurValidate("mixedUse", id, value)}
                    />
                </StyledUnitCountContainer>
                <StyledCenterCell>
                    {elementIndex > 0 && disableInputs !== true && (
                        <StyledShrinkButton onClick={() => onDelete(elementIndex)}>
                            <Delete />
                        </StyledShrinkButton>
                    )}
                </StyledCenterCell>
            </div>
        </div>
    );
};

export default MixedUseDetail;
